import useScreenSize from "@/modules/pe-basic-module/hooks/useScreenSize"
import { IState, IUser, useMainStore } from "@/settings/zustand"
import { IMenuItem, WINDOW_WIDTH } from "@libs/interfaces/layouts"
import { getRouteByRoute } from "@libs/layouts"
import Shortcode from "@libs/useful/shortcode"
import { __, isCapability, setAutoHeightByClass, setMaxHeightByClass } from "@libs/utilities"
import { useEffect } from "react"
import { NavLink } from "react-router-dom"

/* Protopia Ecosystem component */
export interface IMainAdminFormProps {
    extend_params: any
    children: any[]
    route?: string
    description?: string
}
const MainAdminForm = (props: IMainAdminFormProps): JSX.Element => {
    const {width} = useScreenSize()
    const isChildParams = !!props.extend_params && Array.isArray( props.extend_params.child_routes )
    const user: IUser = useMainStore((state: IState) => state.user)

    useEffect(() => {
        if(width > WINDOW_WIDTH.TABLET){
            setMaxHeightByClass( "card-title" ) 
            setMaxHeightByClass( "card-text" ) 
        } 
        else {
            setAutoHeightByClass( "card-title" ) 
            setAutoHeightByClass( "card-text" ) 
        }
    }, [width])
    const menus = (
        isChildParams
            ?
            props.extend_params.child_routes
                .filter( (route: string) => {
                    const rt:IMenuItem | null = getRouteByRoute(route)
                    return !!rt && !rt.is_hidden 
                })
                    .map((route: string) => {
                        return getRouteByRoute(route)
                    })
            :
            !!props.children?.length
                ?
                props.children
                :
                []
    )
        .map((e: IMenuItem, i: number) => {
            const isRole = isCapability(e.capability || [], user)
            if(isRole) return null
            const url = ( isChildParams 
                ?  
                `/${e.route}` 
                : 
                `/${ props.route }/${e.route}` 
                ).replace(/\/+/g,'/')
            return (
                <div className="col-md-3 p-1" key={i}> 
                    <div className="card pe-light text-center text-secondary border-0" >
                        <div 
                            className="card-image thumbnail w-100 h-100"
                            style={{
                                minHeight: 180, 
                                backgroundImage: `url(${ e.thumbnail })`
                            }}
                        >
                            <div className="card-image-icon">
                                <div className={e.icon}></div>
                            </div>
                        </div>
                        <div className="card-body d-flex flex-column align-items-center">                
                            <h4 className="card-title p-2 m-0" >
                                <Shortcode content={__(e.title)} /> 
                            </h4>
                            <Shortcode className="card-text px-2  pb-3"  content={__(e.description)} /> 
                            <NavLink
                                to={url}
                                className="btn btn-outline-secondary text-right mt-auto rounded-pill px-4"
                            >
                                { __( "Goto" ) }
                            </NavLink>
                        </div> 
                    </div>
                </div>
            )
        })
    return <div className="layout-app-state flex-centered">
        <div className="container h-100 flex-centered flex-column pb-5">
            <Shortcode content={ __(props.description || "")} className="letter-spacing-2 my-4 "  /> 
            <div className="row w-100 justify-content-center mb-5">
                {menus}
            </div>
        </div> 
    </div> 
} 
export default MainAdminForm